import { render, staticRenderFns } from "./nature3.vue?vue&type=template&id=4838a34f&scoped=true&"
import script from "./nature3.vue?vue&type=script&lang=js&"
export * from "./nature3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838a34f",
  null
  
)

export default component.exports